<div class="import-questionnaire-btn">
  <button mat-button cdkFocusInitial class="text-white bg-secondary px-4 float-right" *ngIf="parentQuestionnaireId && hasUpdates && masterOrg"
          (click)="showParentQuestionnaire()">
    IMPORT
  </button>
  <button mat-button cdkFocusInitial class="text-white bg-secondary px-4 float-right me-2" *ngIf="parentQuestionnaireId && hasUpdates"
          (click)="publishQuestionnaire(false)">
    MARK DONE
  </button>
  <button mat-button cdkFocusInitial class="text-white bg-secondary px-4 float-right" *ngIf="isMaster && allowEditing"
          (click)="publishQuestionnaire(true)">
    PUBLISH
  </button>
</div>
<div class="questionnaire-tabs-wrapper" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="tabsdrop($event)">
  <mat-tab-group class="px-3 mt-2" color="accent" (selectedTabChange)="filter($event.index)"
                 [selectedIndex]="editedIndex">
    <mat-tab *ngFor="let tab of tabs; let index = index" [label]=tab.name>
      <ng-template mat-tab-label>
        <div class="d-flex justify-content-between example-box" cdkDrag>
          <div class="mt-2">{{tab.name}}</div>
          <mat-icon class="ms-3 fs-6 mt-2 show-icons" (click)="editTabName(index, tab)" *ngIf="allowEditing">edit</mat-icon>
          <mat-icon *ngIf="tabs.length > 1 && allowEditing" class="fs-6 mt-2 show-icons" (click)="deleteTabName(index, tab)">delete_outline</mat-icon>
          <mat-icon *ngIf="tabs.length > 1 && allowEditing" cdkDragHandle class="fs-6 mt-2 show-icons c-move">drag_indicator</mat-icon>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab class="add-tab" *ngIf="tabs.length > 0 && allowEditing">
      <ng-template mat-tab-label>
        <mat-icon matTooltip="Add New Section" (click)="onAddNewTab()">add_circle</mat-icon>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>

<div cdkDropList class="row qs-create mt-2" (cdkDropListDropped)="drop($event)">
  <div class="columns medium-12 mt-2 d-flex qs-body" *ngFor="let question of questions; let index = index" cdkDrag>
    <div class="flex-grow-1 qs-card mb-2">
      <mat-card class="py-0">
        <div class="d-flex justify-content-center" *ngIf="allowEditing">
          <mat-icon class="dragIcon" color="purple" cdkDragHandle>drag_handle</mat-icon>
        </div>
        <div class="d-flex">
          <div class="pe-2">{{index + 1}}.</div>
          <div class="flex-grow-1 c-pointer" (click)="onAction('edit', index)">
            <div class="d-flex">
              <p [innerHTML]="question.questionHtml"></p>
            </div>
            <div class="d-flex flex-dir-column">
              <mat-form-field class="w-75" *ngIf="question.type === 'Short Answer'">
                <input matInput [disabled]="true" [placeholder]= question.placeholder>
              </mat-form-field>

              <mat-form-field *ngIf="question.type === 'Long Answer'">
                <textarea class="border-0 shadow-none bg-transparent" [disabled]="true" matInput [placeholder]= question.placeholder></textarea>
              </mat-form-field>

              <div class="d-flex flex-dir-column" *ngIf="question.type === 'Multiple Choice'">
                <div class="d-flex py-2" *ngFor="let option of question.multipleOptions">
                  <mat-radio-group aria-label="Select an option" class="align-self-center pe-2">
                    <mat-radio-button value="" [disabled]="true" [value]="option.value">{{option.value}}</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>

              <div class="d-flex flex-dir-column" *ngIf="question.type === 'Check Boxes'">
                <div class="d-flex py-2" *ngFor="let checkbox of question.checkboxes; let cdx= index">
                  <mat-checkbox [disabled]="true" class="align-self-center pe-3">{{checkbox.value}}</mat-checkbox>
                </div>
              </div>

              <mat-form-field appearance="fill" class="w-25" *ngIf="question.type === 'Date'">
                <mat-label>Month, Day, Year</mat-label>
                <input matInput [matDatepicker]="dp1" disabled>
                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                <mat-datepicker #dp1></mat-datepicker>
              </mat-form-field>

              <lib-star-rating *ngIf="question.type === 'Rating'" [ratingGiven]="0" [disable]="true"></lib-star-rating>

            </div>
          </div>
          <div class="d-flex flex-dir-column justify-content-between">
            <div class="fs-3 ms-1 fw-bolder text-danger align-self-start" *ngIf="question.mandatory">*</div>
            <mat-icon color="danger" class="add-qs c-pointer fs-6 align-self-end" (click)="onDeleteAction('delete', index)" *ngIf="allowEditing">delete</mat-icon>

            <div *ngIf="!allowEditing">
              <mat-form-field>
                <mat-label>Select your section to import</mat-label>
                <mat-select (selectionChange)="importQuestion($event, question)">
                  <mat-option *ngFor="let section of childSections"
                              [value]="section.id">{{section.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
    <div class="ps-2">
      <mat-icon matTooltip="Add New Question" color="green" class="add-qs align-self-start c-pointer" *ngIf="allowEditing" (click)="onAction('add', index + 1)">add_circle</mat-icon>
    </div>
  </div>
  <div class="row d-flex justify-content-end me-5" *ngIf="questions.length === 0 && !newTab">
    <mat-icon matTooltip="Add New Question" color="green" class="add-qs align-self-start pointer" *ngIf="allowEditing" (click)="onAction('add',0)">add_circle</mat-icon>
  </div>
</div>
